<template>
<div class="pagina-ringraziamento-container">
    <alertRingraziamento :email="email"></alertRingraziamento>
    <div class="row">
    <div :class="this.riepilogoDomandeRisposte.class">
        <riepilogoDomandeRisposteLog
            :setPaginaLoaderCallback="setPaginaRingraziamentoloaderCallback"
            :surveyLogId="paginaRingraziamentoLogId"
            :onGetDataCallback="riepilogoDomandeRisposteDataCallback"
        ></riepilogoDomandeRisposteLog>
    </div>
    <div :class="this.riepilogoDatiUtenteTicket.class">
        <riepilogoDatiUtenteTicket
            :ticketId="ticketId"
            :setPaginaLoaderCallback="setPaginaRingraziamentoloaderCallback"
            :onGetDataCallback="riepilogoDatiUtenteCallback"
        ></riepilogoDatiUtenteTicket>
    </div>
    </div>
    <div class="row">
        <div class="col-12">
            <domandaInoltrata :testoDomanda="testoDomandaInoltrata"></domandaInoltrata>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <ticketAttachmentFileDownloader :ticketId="ticketId"></ticketAttachmentFileDownloader>
        </div>
    </div>
    
</div>
</template>

<script>
import intl from "./intl/intl";
import AlertRingraziamento from "../alerts/alertRingraziamento/AlertRingraziamento.vue"
import RiepilogoDomandeRisposteLog from "../riepilogoDomandeRisposteLog/RiepilogoDomandeRisposteLog.vue"
import RiepilogoDatiUtenteTicket from "../riepilogoDatiUtenteTicket/RiepilogoDatiUtenteTicket.vue"
import DomandaInoltrata from "../domandaInoltrata/DomandaInoltrata.vue"
import TicketAttachmentFileDownloader from "../fileDownloader/TicketAttachmentFileDownloader.vue"
export default {
    name: "paginaRingraziamento",
    mounted() {},
    props: {
        ticketId: {
            type: Number,
            default: null 
        },
        setPaginaLoaderCallback: {
            type: Function,
            default: (value) => {console.log("PAGINA RINGRAZIAMENTO LOADER: ",value)},
        },
        paginaRingraziamentoLogId: {
            type: Number,
            default: null,
        },
        
    },
    components: {
        "alertRingraziamento": AlertRingraziamento,
        "riepilogoDomandeRisposteLog": RiepilogoDomandeRisposteLog,
        "riepilogoDatiUtenteTicket": RiepilogoDatiUtenteTicket,
        "domandaInoltrata": DomandaInoltrata,
        "ticketAttachmentFileDownloader": TicketAttachmentFileDownloader
    },

    data: function () {
        return {
            intl: intl,
            email: null,
            riepilogoDomandeRisposte: {
                loader: false,
                hasData: null,
                class: "insvisible",
            },
            riepilogoDatiUtenteTicket: {
                loader: false,
                hasData: null,
                class: "insvisible",
            },
            testoDomandaInoltrata: null,
            childLoaders: {}


           
            
        };
    },
    methods: {
        setPaginaRingraziamentoloaderCallback(value) {   
            if(value && Object.keys(value) && Object.keys(value)[0]){
                this[Object.keys(value)[0]]["loader"] = value[Object.keys(value)[0]]
            }
            this.setPaginaLoaderCallback({paginaRingraziamentoLoader: this.riepilogoDomandeRisposte.loader || this.riepilogoDatiUtenteTicket.loader})
        },
        riepilogoDomandeRisposteDataCallback: function(data) {
            if(data !== null && data.length > 0){
                this.riepilogoDomandeRisposte.hasData = true
            }else{
                this.riepilogoDomandeRisposte.hasData = false
            }
            this.checkChildClassnames()
        },
        riepilogoDatiUtenteCallback: function(response) {
         
            if(response !== null && response.data && Object.keys(response.data).length > 0){

                this.riepilogoDatiUtenteTicket.hasData = true
                if(response.data.question){
                    this.testoDomandaInoltrata = response.data.question
                }
                if(response.data.email){
                    this.email = response.data.email
                }
            }else{
                this.riepilogoDatiUtenteTicket.hasData = false
            }
            this.checkChildClassnames()
            
        },
        checkChildClassnames: function(){
            if(this.riepilogoDomandeRisposte.hasData !== null && this.riepilogoDatiUtenteTicket.hasData !== null){
                if(this.riepilogoDomandeRisposte.hasData){
                    if(this.riepilogoDatiUtenteTicket.hasData){
                        this.riepilogoDatiUtenteTicket.class = "col-xl-6"
                        this.riepilogoDomandeRisposte.class = "col-xl-6"
                    }else{
                        this.riepilogoDatiUtenteTicket.class = "col-0"
                        this.riepilogoDomandeRisposte.class = "col-12"
                    }
                }else{
                    if(this.riepilogoDatiUtenteTicket.hasData){
                        this.riepilogoDatiUtenteTicket.class = "col-12"
                        this.riepilogoDomandeRisposte.class = "col-0"
                    }else{
                        this.riepilogoDatiUtenteTicket.class = "col-0"
                        this.riepilogoDomandeRisposte.class = "col-0"
                    }
                }
            }
        }
    },
    watch: {
        
        
    },
    computed: {
        paginaLoader: function(){
            let loaders = Object.keys(this.childLoaders)
            let paginaLoader = false
            if(loaders.length > 0){
                loaders.map((loader) => {
                    if(this.childLoaders[loader] === true){
                        paginaLoader = true
                    }
                })
            }
            return paginaLoader
        },
    },
};
</script>
